export default {
  SET_OPEN: '@WS_EDITOR/AI_CHAT/SET_OPEN',
  SET_DISPLAY_MODE: '@WS_EDITOR/AI_CHAT/SET_DISPLAY_MODE',
};
